<div class="container" style="    margin-top: 20px;
height: 400px;" >
    <div class="row">
        <div class="col-12 text-center" style="margin-top: 30px">
            <h4><a style="color:#cb983f; font-size: 40px">Your Order Has Been Successfully Placed </a></h4>
        </div>
        <div class="col-12 text-center" style="margin-top:15px">
           <button class="btn btn-success " (click)="goToOrder()">Manage Order</button>
        </div>
    </div>

<!-- Event snippet for Order Placed Web conversion page -->
<script>
    gtag('event', 'conversion', {
        'send_to': 'AW-943687090/bFYjCIHq64YBELKL_sED',
        'transaction_id': ''
    });
  </script>
  
  
  
</div>
